export * from '@primeuix/themes/lara/card';
export { default } from '@primeuix/themes/lara/card';
